
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProcessMasterDialog extends _Ext.DialogBase<ProcessMasterRow, any> {
        protected getFormKey() { return ProcessMasterForm.formKey; }
        protected getIdProperty() { return ProcessMasterRow.idProperty; }
        protected getLocalTextPrefix() { return ProcessMasterRow.localTextPrefix; }
        protected getNameProperty() { return ProcessMasterRow.nameProperty; }
        protected getService() { return ProcessMasterService.baseUrl; }
        protected getDeletePermission() { return ProcessMasterRow.deletePermission; }
        protected getInsertPermission() { return ProcessMasterRow.insertPermission; }
        protected getUpdatePermission() { return ProcessMasterRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new ProcessMasterForm(this.idPrefix);

        constructor() {
            super();
            q.hideEditorLabel(this.form.InspectionDetails);
            this.form.ProcessCode.changeSelect2(e => {

                var id = ProcessMasterRow.getLookup().items.filter(x => x.ProcessCode.toUpperCase() == this.form.ProcessCode.value)[0];
                if (id != undefined) {
                    if (id.ProcessId != null || id.ProcessId > 0) {
                        Q.notifyError("Duplicate Process " + this.form.ProcessCode.value);
                        this.form.ProcessCode.value = "";
                        return;

                    }
                }
                else {
                    this.form.ProcessCode.value = this.form.ProcessCode.value.toUpperCase();
                }
            });

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            return btns;
        }
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            if (this.form.SysParam.value) {
                Q.alert("Process Cannot be deleted");
                return;
            }

            var refid: LabourMasterRow;
            OMS.LabourMasterService.FilterList({
                ProcessId: self.entityId
            },
                response => {
                if (response.TotalCount> 0)
                    refid = response.Entities[0];
                },
                { async: false }
            );
            if (refid != null) {
                if (refid.ProcessId != null || refid.ProcessId > 0) {
                    Q.alert("Process is in use, Cannot delete");
                    return;
                }
            } else {
                ProcessMasterService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
    }
}